import NovaModal from './NovaModal';

export { NovaModal };
export default NovaModal;
